import { api } from "@/lib/api";
import { Feature, FeatureApiResponse } from "@/types/feature.types";

export const featureService = {
  async getAllFeatures(): Promise<Feature[]> {
    const response = await api.get<FeatureApiResponse>("/features");
    return response.data.data;
  },
};
